(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    const WISHLIST_KEY = 'mondsee_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); }
    catch { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }

  function isWishlisted(id) {
    return getWishlist().some(item => String(item.id) === String(id));
  }

  function toggleWishlist(productData) {
    const list = getWishlist();
    const idx = list.findIndex(item => String(item.id) === String(productData.id));
    if (idx >= 0) {
      list.splice(idx, 1);
      saveWishlist(list);
      return false;
    } else {
      list.push(productData);
      saveWishlist(list);
      return true;
    }
  }

  function updateButtonStates() {
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const id = btn.dataset.productId;
      const wishlisted = isWishlisted(id);
      btn.classList.toggle('is-wishlisted', wishlisted);
      btn.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : `Save ${btn.dataset.productTitle} to wishlist`);
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.wishlist-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const productData = {
      id: btn.dataset.productId,
      title: btn.dataset.productTitle,
      url: btn.dataset.productUrl,
      image: btn.dataset.productImage,
      price: btn.dataset.productPrice,
      compareAtPrice: btn.dataset.productComparePrice,
    };

    const added = toggleWishlist(productData);

    document.querySelectorAll(`.wishlist-btn[data-product-id="${productData.id}"]`).forEach(b => {
      b.classList.toggle('is-wishlisted', added);
      b.setAttribute('aria-label', added ? 'Remove from wishlist' : `Save ${productData.title} to wishlist`);
    });

    btn.classList.add('wishlist-btn--animate');
    btn.addEventListener('animationend', () => btn.classList.remove('wishlist-btn--animate'), { once: true });

    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: getWishlist() } }));
  });

  document.addEventListener('DOMContentLoaded', updateButtonStates);
  if (document.readyState !== 'loading') updateButtonStates();
  } catch(e) { console.error(e); }
})();

})();
